import styled, { keyframes } from 'styled-components';
import { screenUpTo, Screen } from '@client/styles/styled-components/breakpoints';

const animation = keyframes`
  to {
    background-position: 350% 0, 0px 0px, 0px 258px, 0px 280px, 0px 300px, 0 0; /* card bg */
  }
`

export const LoaderCard = styled.div<{ itemWidth: number }>`
  width: ${p => `${p.itemWidth}px`};
  height: 325px;
  padding: 7px;
  background-repeat: no-repeat;
  background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 25%,
      rgba(255, 255, 255, .8) 50%,
      rgba(255, 255, 255, 0) 100%
    ),
    linear-gradient(#f3f3f3 250px, transparent 0),
    linear-gradient(#f3f3f3 15px, transparent 0),
    linear-gradient(#f3f3f3 13px, transparent 0),
    linear-gradient(#f3f3f3 15px, transparent 0),
    linear-gradient(white 100%, transparent 0);
  background-size: 120px 325px, 190px 250px, 130px 40px, 120px 40px, 90px 40px,
    100% 100%; /* card bg */
  background-position: -250% 0, 0px 0px, 0px 258px, 0px 280px, 0px 300px, 0 0; /* card bg */
  animation: ${animation} 2.5s infinite;

  ${screenUpTo(Screen.mobile)}{
    width: ${p => `${p.itemWidth - 7}px`}; /* remove padding */
  };
`;

export const Wrapper = styled.div`
  display:flex;
  justify-content: space-between;
  padding-top: 3%;
`;
